// extracted by mini-css-extract-plugin
export default {"cards":"UserBlogs_cards__vRHof"};